export const INITIALIZE = 'ACTIVATIONMODAL/INITIALIZE';

const initialize = ({ showSuccessStep = false }) => ({
  type: INITIALIZE,
  payload: {
    showSuccessStep,
  },
});

export default initialize;
